// src/components/Testimonial.jsx
import React from 'react';

const Testimonial = () => (
  <section id="testimonials" className="bg-gray-100 text-center py-16">
    <div className="container mx-auto">
     
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="flex justify-center mb-4">
            <div className="w-48 h-48 rounded-full overflow-hidden">
              <img src="/assets/home/michael tully.jpeg" alt="Michael Tully" className="w-full h-full object-cover object-center" style={{ width: '200px', height: '200px', objectFit: 'cover', objectPosition: '50% 50%' }} />
            </div>
          </div>
          <h3 className="font_2 wixui-rich-text__text mb-2" style={{ fontSize: '25px', lineHeight: '1em', textAlign: 'center', fontFamily: 'Montserrat, sans-serif', color: 'rgba(112, 112, 112, 1)', marginTop: '48px', wordWrap: 'break-word', direction: 'var(--text-direction)', minHeight: 'var(--min-height)', minWidth: 'var(--min-width)', mixBlendMode: 'var(--blendMode, normal)', overflowWrap: 'break-word', pointerEvents: 'none', textShadow: 'var(--textOutline, 0 0 transparent), var(--textShadow, 0 0 transparent)', textTransform: 'var(--textTransform, none)' }}>
            <a href="https://www.gensler.com/people/michael-tully" target="_blank" rel="noreferrer noopener" className="wixui-rich-text__text">
              Michael Tully, Studio Director, Gensler
            </a>
          </h3>
          <p className="font_8 wixui-rich-text__text" style={{ lineHeight: '1.7em', textAlign: 'center', fontSize: '16px', fontFamily: 'Montserrat, sans-serif', maxWidth: '500px', margin: '0 auto' }}>
            Always come to the table with the most cost-effective designs that work the best with our vision
            <br />
            of the project.
          </p>
          <div className="flex justify-center mt-12">
            <img src="/assets/home/quotes.png" alt="Quotes" className="w-8 h-8" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="flex justify-center mb-4">
            <div className="w-48 h-48 rounded-full overflow-hidden">
              <img src="/assets/home/jeramy.jpeg" alt="Jeramy Williams" className="w-full h-full object-cover object-center" style={{ width: '200px', height: '200px', objectFit: 'cover', objectPosition: '50% 50%' }} />
            </div>
          </div>
          <h3 className="font_2 wixui-rich-text__text mb-2" style={{ fontSize: '25px', lineHeight: '1em', textAlign: 'center', fontFamily: 'Montserrat, sans-serif', color: 'rgba(112, 112, 112, 1)', marginTop: '48px', wordWrap: 'break-word', direction: 'var(--text-direction)', minHeight: 'var(--min-height)', minWidth: 'var(--min-width)', mixBlendMode: 'var(--blendMode, normal)', overflowWrap: 'break-word', pointerEvents: 'none', textShadow: 'var(--textOutline, 0 0 transparent), var(--textShadow, 0 0 transparent)', textTransform: 'var(--textTransform, none)' }}>
            <a href="https://www.linkedin.com/in/jeramy-williams-architect-ncarb-76204511/" target="_blank" rel="noreferrer noopener" className="wixui-rich-text__text">
              Jeramy Williams, Principal, JAW Arch
            </a>
          </h3>
          <p className="font_8 wixui-rich-text__text" style={{ lineHeight: '1.7em', textAlign: 'center', fontSize: '16px', fontFamily: 'Montserrat, sans-serif', maxWidth: '500px', margin: '0 auto' }}>
            Able to present creative ideas and communicate positive solutions, that have resulted
            <br />
            in increased client satisfaction.
          </p>
          <div className="flex justify-center mt-12">
            <img src="/assets/home/quotes.png" alt="Quotes" className="w-8 h-8" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Testimonial;
